import { render, staticRenderFns } from "./StoreRanking.vue?vue&type=template&id=748b07dc&scoped=true&"
import script from "./StoreRanking.vue?vue&type=script&lang=ts&"
export * from "./StoreRanking.vue?vue&type=script&lang=ts&"
import style0 from "./StoreRanking.vue?vue&type=style&index=0&id=748b07dc&prod&lang=sass&scoped=true&"
import style1 from "./StoreRanking.vue?vue&type=style&index=1&id=748b07dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748b07dc",
  null
  
)

/* custom blocks */
import block0 from "./StoreRanking.vue?vue&type=custom&index=0&blockType=i18n&locale=en-us&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./StoreRanking.vue?vue&type=custom&index=1&blockType=i18n&locale=ja&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports
import {QSkeleton,QCard,QCardSection,QIcon,QTooltip,QSelect,QSeparator,QTable,QTh,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSkeleton,QCard,QCardSection,QIcon,QTooltip,QSelect,QSeparator,QTable,QTh,QTd})
